module.exports = require("./sa.d.ts");